export default __webpack_public_path__ + "static/media/monkey2.4442d504.png";